/**
 * Fashion Show Reel types and constants
 */

export type PlaybackSpeed = 'slow' | 'normal' | 'fast';

export type NarratorVoice = 'male' | 'female';

export type ReelState = 'setup' | 'loading' | 'playing' | 'completed' | 'error';

export const SPEED_DURATIONS: Record<PlaybackSpeed, number> = {
  slow: 8000,
  normal: 5000,
  fast: 3000,
};

export const EVENT_TYPES = [
  'Casual', 'Business Casual', 'Formal', 'Wedding', 'Date Night',
  'Party', 'Graduation', 'Interview', 'Vacation', 'Beach',
  'Workout', 'Festival', 'Brunch', 'Work', 'Travel',
  'Holiday', 'Birthday', 'Anniversary'
] as const;

export type EventType = typeof EVENT_TYPES[number];

export interface NarrationRequest {
  outfitId: string;
  eventType: string;
  description?: string;
  voiceGender?: 'male' | 'female';
  clothingItems: Array<{
    type: string;
    brand: string;
    color: string;
    description: string;
  }>;
  aiAnalysis?: {
    description: string;
    highlights: string[];
    suggestedTags: string[];
  };
}

export interface NarrationResponse {
  audioBase64: string;
  contentType: string;
  descriptionText: string;
  durationMs: number;
}
